var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emd-onboarding" },
    _vm._l(_vm.onboarding, function (item, i) {
      return _c(
        "div",
        {
          key: item.id,
          ref: item.id,
          refInFor: true,
          staticClass: "emd-onboarding__wrapper",
          class: { "eu-display_none": i !== _vm.step },
        },
        [
          _c("emd-pulse", { class: item.pulseDirection }),
          _c("div", { staticClass: "emd-container _content_spaced" }, [
            _c(
              "div",
              [
                _c("emd-status-bar", { attrs: { status: "primary" } }),
                _c(
                  "div",
                  {
                    staticClass:
                      "emd-container__header eu-justify_end eu-align-items_start",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "emd-btn _type_link _color_tertiary",
                        on: { click: _vm.close },
                      },
                      [_c("i", { staticClass: "uil uil-times" })]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "emd-container__content eu-align_center" },
              [
                item.hasImage
                  ? _c(
                      "div",
                      { staticClass: "emd-onboarding__image" },
                      [
                        _c("emeraldraw", {
                          attrs: { draw: "onboarding/" + item.id },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "emd-text _color_default" }, [
                  _c(
                    "h2",
                    { staticClass: "emd-text _size_page _color_default" },
                    [
                      item.showStepNumber
                        ? _c("span", [_vm._v(_vm._s(i + 1) + ". ")])
                        : _vm._e(),
                      _vm._v(_vm._s(_vm.$t(item.id + ".title")) + " "),
                    ]
                  ),
                  _c("div", {
                    staticClass: "eu-my_5",
                    domProps: { innerHTML: _vm._s(_vm.$t(item.id + ".text")) },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "emd-container__footer eu-align_center eu-mb_3" },
              [
                _c(
                  "div",
                  { staticClass: "eu-flex eu-justify_end eu-mb_3 eu-px_4" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "emd-btn _color_tertiary",
                        on: { click: _vm.close },
                      },
                      [_vm._v(_vm._s(_vm.$t(item.id + ".button")))]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }